
// @ts-nocheck


export const localeCodes =  [
  "en",
  "us",
  "es",
  "fr",
  "de"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45GB_46json_69befa78",
      load: () => import("#nuxt-i18n/69befa78" /* webpackChunkName: "locale_en_45GB_46json_69befa78" */),
      cache: true
    }
  ],
  us: [
    {
      key: "locale_en_45US_46json_5111540e",
      load: () => import("#nuxt-i18n/5111540e" /* webpackChunkName: "locale_en_45US_46json_5111540e" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_45ES_46json_72cb0d9a",
      load: () => import("#nuxt-i18n/72cb0d9a" /* webpackChunkName: "locale_es_45ES_46json_72cb0d9a" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_cc7b158e",
      load: () => import("#nuxt-i18n/cc7b158e" /* webpackChunkName: "locale_fr_45FR_46json_cc7b158e" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_45DE_46json_fede64e1",
      load: () => import("#nuxt-i18n/fede64e1" /* webpackChunkName: "locale_de_45DE_46json_fede64e1" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: true
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      language: "en-GB",
      files: [
        {
          path: "/app/i18n/locales/en-GB.json",
          cache: undefined
        }
      ]
    },
    {
      code: "us",
      name: "American English",
      iso: "en-US",
      files: [
        {
          path: "/app/i18n/locales/en-US.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Español",
      language: "es-ES",
      files: [
        {
          path: "/app/i18n/locales/es-ES.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      language: "fr-FR",
      files: [
        {
          path: "/app/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      language: "de-DE",
      files: [
        {
          path: "/app/i18n/locales/de-DE.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_lang",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true,
    onlyOnRoot: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  seo: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: "en-GB",
    files: [
      {
        path: "/app/i18n/locales/en-GB.json",
        cache: undefined
      }
    ]
  },
  {
    code: "us",
    name: "American English",
    iso: "en-US",
    files: [
      {
        path: "/app/i18n/locales/en-US.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    language: "es-ES",
    files: [
      {
        path: "/app/i18n/locales/es-ES.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    language: "fr-FR",
    files: [
      {
        path: "/app/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    language: "de-DE",
    files: [
      {
        path: "/app/i18n/locales/de-DE.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/